import {
  isIosNativeApp as isIosApp,
  isAndroidNativeApp as isAndroidApp,
  isNativeApp,
  isGamingWrapperApp,
} from '@central-products/wh-app-detector';
import { ANDROID_UK_VEGAS_NATIVE_APP_USER_AGENT, ANDROID_SPAIN_VEGAS_NATIVE_APP_USER_AGENT } from '../constants';

const ANDROID_LEGACY_GAMING_USER_AGENTS = [
  ANDROID_UK_VEGAS_NATIVE_APP_USER_AGENT,
  ANDROID_SPAIN_VEGAS_NATIVE_APP_USER_AGENT,
];

export const isApplication = (callback) => {
  if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
    return false;
  }

  return callback(window.navigator.userAgent);
};

export const isNative = () => isApplication(isNativeApp);
export const isIos = () => isApplication(isIosApp);
export const isAndroid = () => isApplication(isAndroidApp);
export const isGamingWrapper = () =>
  isApplication(
    (userAgent) =>
      isGamingWrapperApp(userAgent) || ANDROID_LEGACY_GAMING_USER_AGENTS.some((ua) => userAgent.includes(ua))
  );
